// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--t8koA","pin":"_7a3fb80146--pin--LHKdC","slidein":"_7a3fb80146--slidein--t1X3H","label":"_7a3fb80146--label--VF8al"};